/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */

import React from "react";
import { Link } from "react-router-dom";

export const DonateBankDetails: React.FC = () => {
    return (
        <div className="card card-bank-details jc-border-12">
            <div className="card-header card-header-bg">
                <p className="jc-txt-heading fs-5">Banking Details</p>
            </div>
            <div className="card-body p-0">
                <ul className="list-group list-group-flush jc-txt-body">
                    <li className="list-group-item fw-bold p-3">Cemetery Maintenance Board</li>
                    <li className="list-group-item fw-bold p-3">ABSA</li>
                    <li className="list-group-item p-3">
                        <div className="d-flex justify-content-between">
                            <span>Wynberg</span>
                            <span>632005</span>
                        </div>
                    </li>
                    <li className="list-group-item p-3">
                        <div className="d-flex justify-content-between">
                            <span>Account</span>
                            <span>01023530534</span>
                        </div>
                    </li>
                    <li className="list-group-item p-3" style={{borderBottomLeftRadius: "12px!important", borderBottomRightRadius: "12px!important"}}>
                        <div className="d-flex justify-content-center">
                            <Link to="/terms-conditions" className="fw-bold jc-txt-blue">Terms & Conditions</Link>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );
}